import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { AUTH_QUERY_KEYS, AUTH_ROUTES } from '../constants';
import type { RegisterFormValues } from '../schemas';
import { authService } from '../services';
import { useAuthStore } from './use-auth-store';

/** Mutation de cadastro: cria a conta, ja loga (autoSignIn) e redireciona. */
export function useRegister() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const setUser = useAuthStore((state) => state.setUser);

  return useMutation({
    mutationFn: (values: RegisterFormValues) =>
      authService.register({
        name: values.name,
        email: values.email,
        password: values.password,
      }),

    onSuccess: async (data) => {
      setUser(data.user);
      await queryClient.invalidateQueries({ queryKey: AUTH_QUERY_KEYS.me });
      navigate(AUTH_ROUTES.DASHBOARD, { replace: true });
    },
  });
}
